module.exports = __webpack_public_path__ + "logo-nlw.dda14978.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logos/logo-nlw.svg
// module id = N3bH
// module chunks = 0